export const dict = {
  ms: {
    registrationOpen: "PENDAFTARAN DIBUKA",
    bookSeat: "Booking Seat",
    heroBadgeExtra: " // SESI EKSKLUSIF",
    noFee: "Tiada Yuran !",
    noDeposit: "Tiada Deposit !",
    heroText: "Tempah seat anda untuk private class bersama Rahsia Trading. Isi borang, sertai Telegram, dan dapatkan info seterusnya.",
    heroCta: "Booking Seat Sekarang",
    sessionLabel: "SESI PRIVATE CLASS",
    feeChip: "YURAN",
    marquee: ["Private Class", "Tiada Yuran", "Tiada Deposit", "Rahsia Trading", "Seat Terhad", "Zoom Online"],
    cdEyebrow: "01 — COUNTDOWN",
    cdTitleA: "Kelas ",
    cdTitleB: "bermula",
    cdTitleC: " dalam",
    classDate: "TARIKH KELAS",
    live: "Kelas Sedang Berlangsung",
    units: ["HARI", "JAM", "MINIT", "SAAT"],
    bookEyebrow: "02 — BOOKING SEAT",
    bookTitleA: "Tempah seat ",
    bookTitleB: "anda",
    bookTitleC: " sekarang.",
    steps: ["Isi borang booking", "Dapat pengesahan booking", "Join Telegram untuk info seterusnya"],
    pastSession: "SESI LEPAS",
    formTitle: "BORANG BOOKING",
    seatsLeft: "BAKI SEAT",
    booked: "sudah booking",
    fields: {
      nama: ["Nama", "Nama penuh anda"],
      phone: ["Number Fon", "012-345 6789"],
      email: ["Email", "anda@email.com"],
      telegram: ["Telegram Username", "@username"],
    },
    errors: {
      nama: "Sila isi nama penuh anda.",
      phone: "Sila isi nombor telefon yang sah.",
      email: "Format email tidak sah. Contoh: nama@gmail.com",
      telegram: "Username Telegram tidak sah. 5-32 aksara, mula dengan huruf, hanya huruf/nombor/_ . Contoh: @ahmad_trading",
    },
    submit: "Booking Seat Saya",
    formNote: "Percuma. Tiada yuran. Tiada deposit.",
    submitFail: "Gagal menghantar. Cuba lagi.",
    successTitle: "Booking Berjaya!",
    successPre: "Thankyou kerana telah booking seat untuk private class,",
    successPost: "join link telegram ni untuk dapat info seterusnya.",
    joinTelegram: "Join Telegram",
    shareFriend: "Kongsi kepada kawan",
    shareText: "Jom join Private Class Rahsia Trading! Tiada Yuran, Tiada Deposit. Booking seat percuma di sini:",
    fbEyebrow: "03 — FEEDBACK",
    fbTitleA: "Apa kata ",
    fbTitleB: "peserta",
    fbHint: "Tekan gambar untuk lihat dengan lebih jelas.",
    fbAlt: "Feedback peserta",
    themeLight: "Mod cerah",
    themeDark: "Mod gelap",
  },
  en: {
    registrationOpen: "REGISTRATION OPEN",
    bookSeat: "Book Seat",
    heroBadgeExtra: " // EXCLUSIVE SESSION",
    noFee: "No Fees !",
    noDeposit: "No Deposit !",
    heroText: "Reserve your seat for the private class with Rahsia Trading. Fill in the form, join Telegram, and get the next details.",
    heroCta: "Book Your Seat Now",
    sessionLabel: "PRIVATE CLASS SESSION",
    feeChip: "FEE",
    marquee: ["Private Class", "No Fees", "No Deposit", "Rahsia Trading", "Limited Seats", "Zoom Online"],
    cdEyebrow: "01 — COUNTDOWN",
    cdTitleA: "Class ",
    cdTitleB: "starts",
    cdTitleC: " in",
    classDate: "CLASS DATE",
    live: "Class Is Live Now",
    units: ["DAYS", "HOURS", "MINS", "SECS"],
    bookEyebrow: "02 — BOOK A SEAT",
    bookTitleA: "Reserve ",
    bookTitleB: "your",
    bookTitleC: " seat now.",
    steps: ["Fill in the booking form", "Get your booking confirmation", "Join Telegram for the next details"],
    pastSession: "PAST SESSION",
    formTitle: "BOOKING FORM",
    seatsLeft: "SEATS LEFT",
    booked: "booked",
    fields: {
      nama: ["Name", "Your full name"],
      phone: ["Phone Number", "012-345 6789"],
      email: ["Email", "you@email.com"],
      telegram: ["Telegram Username", "@username"],
    },
    errors: {
      nama: "Please enter your full name.",
      phone: "Please enter a valid phone number.",
      email: "Invalid email format. Example: name@gmail.com",
      telegram: "Invalid Telegram username. 5-32 characters, start with a letter, letters/numbers/_ only. Example: @ahmad_trading",
    },
    submit: "Book My Seat",
    formNote: "Free. No fees. No deposit.",
    submitFail: "Failed to submit. Please try again.",
    successTitle: "Booking Confirmed!",
    successPre: "Thank you for booking a seat for the private class,",
    successPost: "join this Telegram link to get the next details.",
    joinTelegram: "Join Telegram",
    shareFriend: "Share with a friend",
    shareText: "Join the Rahsia Trading Private Class! No Fees, No Deposit. Book your free seat here:",
    fbEyebrow: "03 — FEEDBACK",
    fbTitleA: "What ",
    fbTitleB: "students",
    fbHint: "Tap an image to view it larger.",
    fbAlt: "Student feedback",
    themeLight: "Light mode",
    themeDark: "Dark mode",
  },
};
